<template>
    <img src="https://d3a6n7gvbr88rj.cloudfront.net/Guided-Journey/Logos/Light.svg" />
</template>
